export const infoItemComponents = {
    BIDS: 'BIDS',
    TIME_LEFT: 'TIME_LEFT',
    ITEM_PRICE: 'ITEM_PRICE'
};
